import { Grid2, Typography } from '@mui/material'
import styles from './GroceryList.module.css'
import { GoBackIcon } from '../../utils/iconRefs/recipeRatingIcons'
import { useHistory } from 'react-router-dom';
import { ThreeDotsIcon } from '../../iconRef/groceryListIcons';
import GroceryListTitle from '../../components/groceryList/groceryListTitle/GroceryListTitle';
import GroceryListCategories from '../../components/groceryList/groceryListCategories/GroceryListCategories';
import useFetchGroceryList from '../../hooks/useFetchGroceryList';
import useCheckHistory from '../../hooks/useCheckHistory';
import { useAppSelector } from '../../app/store/hooks';

import Loader from '../mealPlan/Loader';
import { GroceryList } from '../../app/commonSelector';


const GroceryListContainer = () => {
    const history = useHistory();
    const { loading: groceryListLoader, refetch } = useFetchGroceryList()
    const goBackOrRedirect = useCheckHistory();
    const groceryListItems = useAppSelector(GroceryList);
    const onBack = () => {
        goBackOrRedirect("/");
    }


    return (
        <Grid2 className={styles.container} container>
            <Grid2 className={styles.title_container}>
                <Grid2 className={styles.title_text_container}>
                    <GoBackIcon onClick={onBack} />
                    <Typography className={styles.title} variant="h6">
                        Grocery List
                    </Typography>
                </Grid2>
                {/* <Grid2>
                    <ThreeDotsIcon />
                </Grid2> */}
            </Grid2>
            {groceryListItems?.length ?
                <>
                    <GroceryListTitle />
                    <GroceryListCategories refetchGrocery={refetch} />
                </>
                :
                <Grid2 className={styles.no_grocery_text_container}>
                    <Typography textAlign="center" className={styles.no_grocery_text}>No ingredients found.</Typography>
                    <Typography textAlign="center" className={styles.no_grocery_text}>To add ingredients to the list, add recipes in the 'Planner' section.</Typography>
                </ Grid2>
            }
            <Loader loading={groceryListLoader} />
        </Grid2>
    )
}

export default GroceryListContainer
